import React from 'react';

import { isNil } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import Preview from 'components/Pages/Admin/shared/Preview';
import Button from 'components/shared/Button';
import Icon from 'components/shared/Icon';
import Visibility from 'components/shared/Icon/icons/Visibility';
import Modal from 'components/shared/Modal';
import { closeModalAction, openModalAction } from 'store/modal';
import { isModalOpenedSelector, modalDataSelector } from 'store/modal/selectors';

import PopupActionButtons from '../../../PopupActionButtons';
import { useEditorContext } from '../../context';
import styles from './index.module.css';

const AreaSelect = React.forwardRef(({ property, onPrevPage }, ref) => {
  const dispatch = useDispatch();
  const { resetEditingBlockState, handleAddAreaToEntity, handleRemoveAreaFromEntity, handleOpenMyOwnAreaSelect } =
    useEditorContext();
  const doesPropertyHaveArea = !isNil(property.areaPageId);
  const isPreviewModalOpen = useSelector(isModalOpenedSelector('AREA_PREVIEW'));
  const modalData = useSelector(modalDataSelector);
  const closeModal = () => {
    dispatch(closeModalAction());
  };
  const openModal = (pageId) => {
    dispatch(openModalAction({ type: 'AREA_PREVIEW', data: { pageId } }));
  };

  return (
    <div ref={ref} className={styles.container}>
      <div className={styles.header}>
        <div className={styles.title}>Would you like to include the area page?</div>

        <Icon
          component={Visibility}
          width="14px"
          height="10px"
          className={styles.previewButton}
          onClick={() => {
            openModal(property.areaPageId);
          }}
        />
      </div>

      <div className={styles.buttonContainer}>
        <Button
          size="medium"
          disabled={!doesPropertyHaveArea}
          onClick={() => {
            handleAddAreaToEntity({ name: property.areaName, id: property.areaPageId, handle: property.areaHandle });
            resetEditingBlockState();
          }}
        >
          Yes
        </Button>
        <Button
          size="medium"
          type="default"
          onClick={() => {
            handleRemoveAreaFromEntity();
            resetEditingBlockState();
          }}
        >
          No
        </Button>
        <Button
          type="default"
          size="medium"
          onClick={() => {
            handleOpenMyOwnAreaSelect({
              countryId: property.countryId,
              propertyId: property.propertyId,
            });
          }}
        >
          Choose my own
        </Button>
      </div>

      <PopupActionButtons onPrevPage={onPrevPage} />

      <Modal noPadding size="lg" isOpen={isPreviewModalOpen} toClose={closeModal}>
        {isPreviewModalOpen && <Preview pageId={modalData.pageId} />}
      </Modal>
    </div>
  );
});

export default AreaSelect;
